import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Question } from '@empathy/survey-core';

import { CopyHiddenChoicesConfirmationComponent } from './copy-hidden-choices-confirmation/copy-hidden-choices-confirmation.component';
import { IQuestionOptionForm } from '../../../models/type-forms/question-form-group.interface';
import { QuestionOptionForm } from '../../../models/type-forms/question-option-form.model';
import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-hidden-choice-settings',
  templateUrl: 'hidden-choice-settings.component.html',
  styleUrls: ['./hidden-choice-settings.component.scss', './_hidden-choice-settings-theme.component.scss']
})
export class HiddenChoiceSettingsComponent implements OnInit, OnChanges {
  @Input() activeQuestion: FormGroup;

  questionToCopyFromCtrl = new FormControl();
  hiddenQuestionsToCopyOptionsFrom: Question[] = [];

  constructor(
    private dialog: MatDialog,
    private surveyEditorService: SurveyEditorService
  ) {}

  get options(): FormArray<FormGroup<IQuestionOptionForm>> {
    return this.activeQuestion.get('options') as FormArray<FormGroup<IQuestionOptionForm>>;
  }

  ngOnInit(): void {
    this.questionToCopyFromCtrl.valueChanges.subscribe((questionId: string) => {
      this.questionToCopyFromCtrl.reset('', { emitEvent: false });
      if (this.activeQuestion.value.options.length > 0) {
        const dialogRef = this.dialog.open(CopyHiddenChoicesConfirmationComponent);

        dialogRef.afterClosed().subscribe((action) => {
          if (!action) {
            return;
          }

          this.patchOptionsArray(questionId);
        });
      } else {
        this.patchOptionsArray(questionId);
      }
    });
  }

  ngOnChanges(): void {
    this.hiddenQuestionsToCopyOptionsFrom = this.surveyEditorService.surveyEditor$().questionsHidden.filter((q) => q.id !== this.activeQuestion.value.id);
  }

  private patchOptionsArray(questionId: string): void {
    this.options.clear();

    const optionsToCopy = this.hiddenQuestionsToCopyOptionsFrom.find((q) => q.id === questionId)?.options || [];
    optionsToCopy.forEach((option) => {
      this.options.push(new QuestionOptionForm(option).form);
    });
  }
}
